<template>
  <div class="content">
    <div class="top"></div>

    <div class="center">
      <div class="profile">
        <van-image round class="user_img" :src="userInfo.header_img">
          <template v-slot:error>
            <van-image src="img/nan/11.png"></van-image>
          </template>
        </van-image>
        <div class="user">
          <div>{{ userInfo.username }}</div>
          <van-image src="img/user/vip.png" width="90"></van-image>
        </div>
        <div class="score">{{ $t('user.label') }}: {{ changeMoney(userInfo.xinyufen) }}</div>
        <div class="line">
          <div class="process"><div class="inside"></div></div>
          <div class="label">{{ $t('user.process') }}{{ changeMoney(userInfo.total_recharge_money) }}</div>
        </div>
      </div>

      <div class="card2 animate__animated animate__flipInX">
        <div class="balance-main">
          <div class="balance-label">{{$t("user.balance")}}</div>
          <div class="balance-row">
            <div class="jiner">{{changeMoney(this.userInfo.money)}}</div>
            <div class="refresh-btn">
              <i class="van-icon van-icon-replay"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="card1">
        <div class="left" @click="goPage('/Recharge')">
          <van-image src="img/user/top_icon1.png" width="26"></van-image>
          <div>{{ $t("user.recharge") }}</div>
        </div>
        <div class="right" @click="doWithdrawal()">
          <van-image src="img/user/top_icon2.png" width="26"></van-image>
          <div>{{ $t("user.withdraw") }}</div>
        </div>
      </div>

      <div class="card3">
        <div class="block" v-for="(item, index) in menuList" :key="index" @click="goPage(item.url)">
          <van-image :src="item.icon" width="26"></van-image>
          <div class="label">{{ item.label }}</div>
          <span v-if="item.url === '/Notice' && noticeUnread" class="notice-dot"></span>
        </div>
      </div>

      <div class="btn" @click="loginout()">{{ $t('user.logout') }}</div>
    </div>
  </div>
</template>

<script>
import { resolveWithdrawConfig } from '@/common/withdrawForm';
import { closeWs } from '@/common/ws';

export default {
  data() {
    return {
      userInfo:{},
      menuList: [
        { label: this.$t("user.icon1"), icon: '/img/user/icon1.png', url: '/Info' },
        { label: this.$t("user.icon8"), icon: '/img/user/icon2.png', url: '/WithdrawRecord' },
        { label: this.$t("user.icon3"), icon: '/img/user/icon3.png', url: '/Liushui' },
        { label: this.$t("user.icon4"), icon: '/img/user/icon4.png', url: '/GameRecord' },
        { label: this.$t("user.icon5"), icon: '/img/user/icon5.png', url: '/Notice' },
        { label: this.$t("user.icon6"), icon: '/img/user/icon6.png', url: '/ChongRecord' },
        { label: this.$t("user.icon2"), icon: '/img/user/icon7.png', url: '/SetLoginPassword' },
        { label: this.$t("user.icon7"), icon: '/img/user/icon8.png', url: '/SetPayPassword' },
      ],
      isLoading: false,
    };
  },
  computed: {
    noticeUnread() {
      return this.$store.state.noticeUnread
    }
  },
  watch: {
    // 全局 WS 刷新余额后，同步当前页面展示
    '$store.state.userInfo': {
      handler(val) {
        if (val && Object.keys(val).length) this.userInfo = val
      },
      deep: true
    }
  },
  methods: {
    goPage(url) {
      this.$router.push({ path: url })
    },
    refresh(){
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        if(localStorage.getItem('token')){
          this.$toast(this.$t("reservation.refresh"));
        }else{
          this.$router.push({path:'/Login'})
        }
      }, 500);
    },
    exit(){
      this.$router.push("Setbank");
    },
    showSetting() {
      if(localStorage.getItem('token')){
        this.$router.push({path:'/Setting'})
      }else{
        this.$router.push({path:'/Login'})
      }
    },
    toNotice(){
      if(localStorage.getItem('token')){
        this.$router.push({path:'/Notice'})
      }else{
        this.$router.push({path:'/Login'})
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        if(localStorage.getItem('token')){
            this.getUserInfo();
            this.$toast(this.$t("reservation.refresh"));
        }else{
            this.$router.push({path:'/Login'})
        }
      }, 500);
    },
    doLogin(){
        if(localStorage.getItem('token')){
            this.$router.push({path:'/Infomation'});
        }else {
            this.$router.push({path:'/Login'})
        }
    },
    doPay(){
      this.$router.push({
        name:'Recharge',
        params:{
          'balance':this.userInfo.money
        }
      })
    },
    doWithdrawal(){
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_config'
      }).then(res=>{
        if(res && res.code === 200){
          const config = resolveWithdrawConfig(res);
          if(config.is_bank || config.account){
            this.$router.push({ path: '/Withdraw' });
          }else {
            this.$router.push({ path: '/BindCard' });
            this.$toast.fail(this.$t("setting.set_bank"));
          }
        }else if(res && res.code ===401){
          this.$toast(res.msg);
        }else {
          this.$toast(this.$t("withdraw.config_error"));
        }
      })
    },
    toService(){
      if(this.$store.getters.getBaseInfo.iskefu == 1){
        this.$router.push("Tx");
      }else {
        this.$router.push("Tx");
        this.$toast.fail(this.$t("setting.forbid"));
      }
    },
    toKefu() {
      console.log(this.$store.getters.getBaseInfo)
      window.open(this.$store.getters.getBaseInfo.kefu)
      // this.$router.push("ServiceOnline");
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          console.log(res)
            this.userInfo = res.data;
            this.menu_top = 15;
            if(this.userInfo.status !== 1){
              this.$toast(this.$t("video.account_out"));
              closeWs()
              localStorage.clear()
              this.$router.push({path:'/Login'})
            }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    loginout(){
        closeWs()
        localStorage.clear()
        this.$router.push({path:'/Login'});
    },
    
    // 价格转换（加逗号）
    changeMoney: (money, type = 'us') => {
      if (isNaN(Number(money))) {
        return '-'
      }
      money = Number(money).toFixed(0)
      const unit1 = type === 'tur' ? '.' : ','
      const x = money.split('.')
      let x1 = x[0]
      const reg = /(\d+)(\d{3})/
      while (reg.test(x1)) {
        x1 = x1.replace(reg, '$1' + unit1 + '$2')
      }
      return `${x1}`
    }
  },
  created() {
    if(localStorage.getItem('token')){
        this.getUserInfo();
    }else {
      this.userInfo.username = this.$t("setting.log_reg");
      this.userInfo.ip = this.$t("setting.more_service");
      this.userInfo.header_img = "img/mine/avatar.png";
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@/assets/css/theme.less';

.content{
  background: @bg-page;
  overflow: auto;
  height: 100%;
  padding-bottom: 5rem;
}

.top{
  height: 8.2rem;
  background:
    linear-gradient(160deg, rgba(247, 161, 192, 0.94) 0%, rgba(195, 163, 242, 0.92) 58%, rgba(255, 190, 156, 0.9) 100%),
    url(/public/img/user/usertop.png) no-repeat center / cover;
}

.center{
  width: 90%;
  margin: -3.4rem auto 0;
  position: relative;
  z-index: 2;

  .profile {
    background: #fff;
    border-radius: 1.35rem;
    box-shadow: 0 0.55rem 1.5rem rgba(183, 156, 236, 0.18);
    padding: 0 1.1rem 1.05rem;
    text-align: center;
    .user_img {
      width: 4.6rem;
      height: 4.6rem;
      margin-top: -2.3rem;
      border: 0.22rem solid #fff;
      box-shadow: 0 0 0 0.16rem rgba(245, 154, 184, 0.7), 0 0.35rem 0.9rem rgba(120, 80, 170, 0.22);
      ::v-deep img {
        border-radius: 50%;
      }
    }
    .user {
      margin-top: 0.55rem;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      gap: 0.35rem;
      div {
        color: @text-title;
        font-size: 1.15rem;
        font-weight: 700;
      }
    }
    .score {
      margin-top: 0.35rem;
      font-size: 0.86rem;
      color: @text-body;
    }
    .line {
      margin-top: 0.7rem;
      display: flex;
      align-items: center;
      gap: 0.55rem;
      .process {
        width: 7.2rem;
        flex-shrink: 0;
        height: 0.32rem;
        border-radius: @radius-pill;
        background: #f3e8f6;
        .inside {
          width: 80%;
          height: 0.32rem;
          border-radius: @radius-pill;
          background: @grad-primary;
        }
      }
      .label {
        flex: 1;
        min-width: 0;
        text-align: left;
        font-size: 0.78rem;
        color: @text-sub;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .card2{
    margin-top: 0.8rem;
    padding: 0.95rem 1rem;
    border-radius: 1.15rem;
    background: #fff;
    box-shadow: 0 0.35rem 1rem rgba(183, 156, 236, 0.14);
    border-left: 0.28rem solid #f59ab8;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: @text-title;
    .balance-label {
      font-size: 0.82rem;
      color: @text-sub;
      margin-bottom: 0.25rem;
    }
    .jiner {
      font-size: 1.55rem;
      font-weight: 700;
      color: #c45b86;
      line-height: 1.2;
    }
    .balance-row {
      display: flex;
      align-items: center;
    }
    .refresh-btn {
      margin-left: .6rem;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 1.7rem;
      height: 1.7rem;
      font-size: .95rem;
      border-radius: 50%;
      color: #e0739b;
      background: #fff0f5;
    }
    span{
      color: @text-sub;
      font-size: .875rem;
    }
  }

  .card1{
    margin-top: 0.75rem;
    display: flex;
    gap: 0.7rem;
    background: transparent;
    box-shadow: none;
    padding: 0;
    >div{
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 0.4rem;
      min-height: 5.4rem;
      background: #fff;
      border-radius: 1.15rem;
      box-shadow: 0 0.35rem 1rem rgba(183, 156, 236, 0.14);
      color: @text-title;
      font-weight: 600;
      font-size: 0.92rem;
    }
    .van-image{
      margin: 0;
    }
  }

  .card3{
    background: #fff;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0.25rem 0;
    border-radius: 1.2rem;
    box-shadow: 0 0.4rem 1.1rem rgba(183, 156, 236, 0.14);
    margin-top: 0.8rem;
    overflow: hidden;
    >div{
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0.72rem 0.9rem;
      border-bottom: 1px solid #f6eef8;
      &:last-child {
        border-bottom: none;
      }
      .van-image {
        width: 2.35rem !important;
        height: 2.35rem !important;
        flex-shrink: 0;
        border-radius: 0.7rem;
        background: linear-gradient(150deg, @pink-light, @lavender-light);
        display: flex !important;
        align-items: center;
        justify-content: center;
        ::v-deep .van-image__img {
          width: 1.15rem !important;
          height: 1.15rem !important;
          position: static !important;
          object-fit: contain;
        }
      }
      &::after {
        content: '';
        width: 0.42rem;
        height: 0.42rem;
        margin-left: 0.6rem;
        border-right: 2px solid #d7c8e6;
        border-top: 2px solid #d7c8e6;
        transform: rotate(45deg);
        flex-shrink: 0;
      }
    }
    .label {
      flex: 1;
      color: @text-title;
      padding: 0 0 0 0.75rem;
      text-align: left;
      line-height: 1.3;
      font-size: 0.92rem;
    }
    .notice-dot {
      width: 0.42rem;
      height: 0.42rem;
      flex-shrink: 0;
      margin-left: 0.2rem;
      border-radius: 50%;
      background: #ff4d4f;
    }
  }

  .btn{
    width: 100%;
    background: transparent;
    box-shadow: none;
    border: 1px solid rgba(224, 115, 155, 0.7);
    color: #c45b86;
    font-weight: 600;
    letter-spacing: 0.04rem;
    padding: 0.85rem 0;
    border-radius: 0.95rem;
    font-size: .93333rem;
    cursor: pointer;
    margin: 1.1rem auto 2.4rem;
    text-align: center;
  }
}

.user_top {
    width: 92%;
    margin: 0 auto;
    margin-top: 6.25rem;
    flex-direction: column;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 3%;
    .user_img {
    height: 3.75rem;
    width: 3.75rem;
    border: 0.06rem solid #ff1a6d;
  }
  .ro {
    color: #fff;
    background: linear-gradient(90deg, #5820ff, #ff1a6d);
    border-radius: 1.25rem;
    display: flex;
    justify-content: space-between;
    padding-left: 3%;
    padding-right: 3%;
    align-items: center;
    font-size: .6875rem;
    padding-top: 1%;
    padding-bottom: 1%;
    .huang {
      width: 1.09375rem;
      height: .9375rem
    }
  }
}

.but {
  display: flex;
  width: 92%;
  margin: 0 auto;
  justify-content: space-between;
  margin-top: 5%;
  margin-bottom: 5%;
  .chong, .tx {
    width: 48%;
    background-size: 100% 100%;
    height: 3.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background-repeat: no-repeat;
    color: #fff;
  }
  .tx_img {
    width: 2.5rem;
    height: 2.5rem;
    margin-right: 10%;
  }
  .chong {
    background-image: url('@/assets/imgs/mine/2.png');
  }
  .tx {
    background-image: url('@/assets/imgs/mine/1.png');
  }

}

.yue {
  width: 92%;
  margin: 0 auto;
  background-image: url('@/assets/imgs/mine/yue.png');
  background-size: 100% 100%;
  height: 6rem;
  margin-bottom: 2%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  padding-left: 3%;
  padding-right: 3%;
  padding-top: 4%;
  padding-bottom: 4%;

  .refresh-btn {
    margin-left: .9375rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.5625rem;
    height: 1.5625rem;
    font-size: .9375rem;
    border-radius: 50%;
    color: #fff;
    background-color: #c24491;
  }
  .font-gray {
    color: #fff;
  }
  .font-28 {
    font-size: .875rem;
  }
  .jiner {
    font-size: 1.3rem;
  }
}
.menu {
  width: 92%;
  background: #22063a;
  margin: 0 auto;
  margin-top: 5%;
  border-radius: 0.63rem;
  display: flex;
  flex-wrap: wrap;
  padding-left: 3%;
  padding-right: 3%;
  border: 0.06rem solid #c36dfe;
  .row{
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    padding-top: 2%;
    padding-bottom: 2%;
    .left{
      display: flex;
      align-items: center;
      img{
        width: 2.65625rem;
        height: 2.8125rem;
      }
      .label{
        color: #fff;
        font-size: .9rem;
      }
    }
  }
  .line{
    width: 100%;
    height: .0625rem;
    background: #fff;
    opacity: .12;
  }
}
.kefu{
  position: absolute;
  right: 1rem;
  top: 1rem;
  width: 2rem;
}
</style>
